// import React from 'react';
// import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';
// import { styled } from '@mui/material/styles';
// import { Box, Typography } from '@mui/material';
// import GiftIcon from '@mui/icons-material/CardGiftcard';
// import clsx from 'clsx';

// // 🔢 Milestone data
// const milestones = [
//   { quantity: 2, price: 799, gifts: 0 },
//   { quantity: 3, price: 1099, gifts: 3 },
//   { quantity: 4, price: 1499, gifts: 4 },
// ];

// // ✅ Custom step icon component
// const CustomStepIcon = styled('div')(({ theme, ownerState }) => ({
//   backgroundColor: ownerState.active ? '#fff' : '#f5f5f5',
//   zIndex: 1,
//   color: ownerState.active ? '#f97316' : '#9ca3af',
//   width: 40,
//   height: 40,
//   display: 'flex',
//   borderRadius: '50%',
//   justifyContent: 'center',
//   alignItems: 'center',
//   boxShadow: ownerState.active ? '0 0 0 4px rgba(249, 115, 22, 0.3)' : 'none',
//   border: '1px solid #e0e0e0',
// }));

// function StepIconComponent(props) {
//   const { active, className } = props;
//   return (
//     <CustomStepIcon ownerState={{ active }} className={clsx(className)}>
//       <GiftIcon />
//     </CustomStepIcon>
//   );
// }

// // 📦 Gift stepper component
// const GiftStepper = ({ cartQuantity }) => {
//   const activeStep = milestones.findIndex((m) => cartQuantity < m.quantity);

//   const remainingQty = activeStep !== -1
//     ? milestones[activeStep].quantity - cartQuantity
//     : 0;

//   return (
//     <Box className="w-full p-4 bg-[#fff7f2] rounded-xl shadow-sm mb-4">
//       {/* 🔔 Top Alert Text */}
//       {remainingQty > 0 && activeStep !== -1 && (
//         <Typography className="text-sm text-orange-600 text-center mb-3">
//           <span className="font-semibold">Add {remainingQty} product</span> to unlock{' '}
//           <span className="font-semibold">
//             Buy {milestones[activeStep].quantity} @ ₹{milestones[activeStep].price}
//           </span>
//         </Typography>
//       )}

//       {/* 🎁 Stepper */}
//       <Stepper alternativeLabel activeStep={activeStep} className="bg-transparent">
//         {milestones.map((step, index) => (
//           <Step key={index}>
//             <StepLabel StepIconComponent={StepIconComponent}>
//               <div className="flex flex-col items-center mt-2">
//                 <Typography variant="caption" className="font-semibold text-sm">
//                   Buy {step.quantity} @ ₹{step.price}
//                 </Typography>
//                 {step.gifts > 0 && (
//                   <Typography variant="caption" className="text-xs text-gray-500 mt-0.5">
//                     {step.gifts} Free Gift{step.gifts > 1 ? 's' : ''}
//                   </Typography>
//                 )}
//               </div>
//             </StepLabel>
//           </Step>
//         ))}
//       </Stepper>
//     </Box>
//   );
// };

// export default GiftStepper;


import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import GiftIcon from '@mui/icons-material/CardGiftcard';
import clsx from 'clsx';

// 🪄 Milestone data (can be dynamic from backend)
const milestones = [
  { quantity: 2, price: 799, gifts: 0 },
  { quantity: 3, price: 1099, gifts: 3 },
  { quantity: 4, price: 1499, gifts: 4 },
];

// 🎨 Custom icon styling
const CustomStepIcon = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: ownerState.active ? '#fff' : '#f5f5f5',
  zIndex: 1,
  color: ownerState.completed ? '#22c55e' : ownerState.active ? '#f97316' : '#9ca3af',
  width: 40,
  height: 40,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: ownerState.active ? '0 0 0 4px rgba(249, 115, 22, 0.3)' : 'none',
  border: '1px solid #e0e0e0',
}));

// 🔘 Step icon renderer
function StepIconComponent(props) {
  const { active, completed, className } = props;
  return (
    <CustomStepIcon ownerState={{ active, completed }} className={clsx(className)}>
      <GiftIcon />
    </CustomStepIcon>
  );
}

// 🎁 Main Gift Stepper Component
const GiftStepper = ({ cartQuantity }) => {
  // Find the current active milestone step
  let activeStep = milestones.findIndex((m) => cartQuantity < m.quantity);
  if (activeStep === -1) activeStep = milestones.length; // All milestones achieved

  // Calculate next unlockable milestone (if any)
  const nextMilestone = milestones.find((m) => cartQuantity < m.quantity);
  const remainingQty = nextMilestone ? nextMilestone.quantity - cartQuantity : 0;

  return (
    <Box className="w-full p-4 bg-[#fff7f2] rounded-xl shadow-sm mb-4">
      {/* 🔔 Progress Message */}
      {remainingQty > 0 ? (
        <Typography className="text-sm text-orange-600 text-center mb-3">
          <span className="font-semibold">Add {remainingQty} more</span> to unlock{' '}
          <span className="font-semibold">
            Buy {nextMilestone.quantity} @ ₹{nextMilestone.price}
          </span>
          {nextMilestone.gifts > 0 && ` + ${nextMilestone.gifts} Free Gift${nextMilestone.gifts > 1 ? 's' : ''}`}
        </Typography>
      ) : (
        <Typography className="text-sm text-green-600 text-center mb-3 font-semibold">
          🎉 You've unlocked the best gift offer!
        </Typography>
      )}

      {/* 🪜 Stepper */}
      <Stepper alternativeLabel activeStep={activeStep} className="bg-transparent">
        {milestones.map((step, index) => (
          <Step key={index} completed={cartQuantity >= step.quantity}>
            <StepLabel StepIconComponent={StepIconComponent}>
              <div className="flex flex-col items-center mt-2">
                <Typography variant="caption" className="font-semibold text-sm text-gray-700">
                  Buy {step.quantity} @ ₹{step.price}
                </Typography>
                {step.gifts > 0 && (
                  <Typography variant="caption" className="text-xs text-gray-500 mt-0.5">
                    {step.gifts} Free Gift{step.gifts > 1 ? 's' : ''}
                  </Typography>
                )}
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default GiftStepper;

